import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { ThemeService } from './services/theme.service';
import packageJson from '../../package.json';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatIconModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  public version: string = packageJson.version;

  constructor(private themeService: ThemeService) {}

  ngOnInit() {
    // Aplica o tema no componente raiz
    this.themeService.applyThemeIfAvailable();
  }
}
